const API_BASE_URL = '/api'; // Nginx will proxy /api to the backend

interface UserRegistrationData {
  first_name: string;
  last_name: string;
  email: string;
  password: string;
  has_car?: boolean;
  car_motorization?: string;
  has_motorcycle?: boolean;
  needs_pmr?: boolean;
  personal_constraints?: string;
}

export async function login(username: string, password: string) {
  const formBody = new URLSearchParams();
  formBody.append('username', username);
  formBody.append('password', password);

  const response = await fetch(`${API_BASE_URL}/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formBody.toString(),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || 'La connexion a échoué');
  }
  return response.json();
}

export async function register(userData: UserRegistrationData) {
  const response = await fetch(`${API_BASE_URL}/users/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(userData),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || "L'inscription a échoué");
  }
  return response.json();
}

// Generic authenticated API call function
export async function authenticatedApiCall(
  method: string, 
  path: string, 
  token: string | null, 
  data: any = null,
  ignoreResponse: boolean = false
) {
  const headers: HeadersInit = {
    'Authorization': `Bearer ${token}`,
  };

  if (data) {
    headers['Content-Type'] = 'application/json';
  }

  const config: RequestInit = {
    method: method,
    headers: headers,
    body: data ? JSON.stringify(data) : null,
  };

  const response = await fetch(`${API_BASE_URL}${path}`, config);

  if (!response.ok) {
    let errorDetail = `L'appel API vers ${path} a échoué avec le statut ${response.status}`;
    try {
      // Essayer de lire le corps de l'erreur, s'il y en a un
      const errorData = await response.json();
      errorDetail = errorData.detail || errorDetail;
    } catch (e) {
      // Pas de corps JSON dans la réponse d'erreur, on utilise le message par défaut
    }
    throw new Error(errorDetail);
  }

  // Si la réponse est 204 No Content ou si on doit ignorer la réponse, on ne retourne rien.
  if (response.status === 204 || ignoreResponse) {
    return;
  }

  return response.json(); // Sinon, on retourne le JSON.
}
